<template>
  <div>
    <div v-if="loadingOverlay === true">
      <div class="lds-dual-ring"></div>
    </div>

    <div v-if="postDetails !== null">
      <div class="row">
        <p-button outline type="info" size="sm" round @click="$router.go(-1)">
          <i class="fa fa-chevron-circle-left"></i>
          Back
        </p-button>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="row" v-if="postDetails !== null">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      v-if="postDetails.post.mediaType == 'image'"
                      style="width: 100%"
                    >
                      <img
                        v-if="postDetails.post.imageUrlCache !== undefined"
                        :src="postDetails.post.imageUrlCache"
                        alt
                      />
                      <img :src="postDetails.post.imageUrl"  @error="postLoadCache(postDetails.post.shortcode)"  v-else alt />
                    </div>
                    <div
                      v-if="postDetails.post.mediaType == 'video'"
                      style="width: 100%"
                    >
                      <video
                        :poster="postDetails.post.imageUrlCache"
                        v-if="
                          typeof postDetails.post.imageUrlCache !== 'undefined'
                        "
                        controls
                        class="video-contain"
                      >
                        <source
                          v-if="
                            typeof postDetails.post.videoUrlCache !==
                              'undefined'
                          "
                          :src="postDetails.post.videoUrlCache"
                          type="video/mp4"
                        />
                        <source
                          v-else
                          :src="postDetails.post.videoUrl"
                          type="video/mp4"
                        />
                      </video>
                      <video
                        v-else
                        :poster="postDetails.post.imageUrl"
                        @error="postLoadCache(postDetails.post.shortcode)" 
                        controls
                        class="video-contain"
                      >
                        <source
                          v-if="
                            typeof postDetails.post.videoUrlCache !==
                              'undefined'
                          "
                          :src="postDetails.post.videoUrlCache"
                          type="video/mp4"
                        />
                        <source
                          v-else
                          :src="postDetails.post.videoUrl"
                          type="video/mp4"
                        />
                      </video>
                    </div>
                    <div
                      v-if="postDetails.post.mediaType == 'carousel'"
                      style="width: 100%"
                    >
                      <img
                        v-if="postDetails.post.imageUrlCache !== undefined"
                        :src="postDetails.post.imageUrlCache"
                        alt
                      />
                      <img :src="postDetails.post.imageUrl" @error="postLoadCache(postDetails.post.shortcode)"  v-else alt />
                    </div>
                  </div>
                </div>
                <div v-if="loadingPostStats == true">
                  <div class="lds-dual-ring"></div>
                </div>
                <div
                  class="row"
                  v-else-if="postStats !== null"
                  style="position:relative;"
                >
                  <div class="col-md-12" style="text-align:center;">
                    <div
                      class="stats-container"
                      v-if="
                        typeof postDetails.stats.impressionsGraph !==
                          'undefined'
                      "
                    >
                      <h5>{{ postDetails.stats.impressionsGraph }}</h5>
                      <span>impressions</span>
                    </div>
                    <div
                      class="stats-container"
                      v-if="postDetails.stats.reachGraph !== undefined"
                    >
                      <h5>{{ postDetails.stats.reachGraph }}</h5>
                      <span>reach</span>
                    </div>
                    <div
                      class="stats-container"
                      v-if="postDetails.post.viewCount != null"
                    >
                      <h5>{{ postStats.viewCount }}</h5>
                      <span>views</span>
                    </div>
                    <div
                      class="stats-container"
                      v-if="postDetails.stats.likesPublic !== undefined"
                    >
                      <h5>{{ postDetails.stats.likesPublic }}</h5>
                      <span>likes</span>
                    </div>
                    <div class="stats-container" v-else>
                      <h5>{{ postStats.likeCount }}</h5>
                      <span>likes</span>
                    </div>

                    <div
                      class="stats-container"
                      v-if="postDetails.stats.commentsPublic !== undefined"
                    >
                      <h5>{{ postDetails.stats.commentsPublic }}</h5>
                      <span>comments</span>
                    </div>
                    <div class="stats-container" v-else>
                      <h5>{{ postStats.commentCount }}</h5>
                      <span>comments</span>
                    </div>
                    <div
                      class="stats-container"
                      v-if="postEngagementRate != null"
                    >
                      <h5>{{ (postEngagementRate * 100).toFixed(2) }}%</h5>
                      <span>post er</span>
                    </div>
                    <div
                      class="stats-container"
                      v-if="!isNaN(instagramProfileEr)"
                    >
                      <h5>{{ (instagramProfileEr * 100).toFixed(2) }}%</h5>
                      <span>profile er</span>
                    </div>
                  </div>
                </div>

                <div class="row" style="width:100%; position:relative;" v-else>
                  <div
                    class="col-md-12"
                    style="text-align:center;"
                    v-if="postDetails.post.likeCount !== undefined"
                  >
                    <div
                      class="stats-container"
                      v-if="postDetails.post.viewCount !== undefined"
                    >
                      <h5>{{ postDetails.post.viewCount }}</h5>
                      <span>views</span>
                    </div>
                    <div
                      class="stats-container"
                      v-if="postDetails.post.likeCount !== undefined"
                    >
                      <h5>{{ postDetails.post.likeCount }}</h5>
                      <span>likes</span>
                    </div>
                    <div
                      class="stats-container"
                      v-if="postDetails.post.commentCount !== undefined"
                    >
                      <h5>{{ postDetails.post.commentCount }}</h5>
                      <span>comments</span>
                    </div>
                    <div
                      class="stats-container"
                      v-if="postEngagementRate !== null"
                    >
                      <h5>{{ (postEngagementRate * 100).toFixed(2) }}%</h5>
                      <span>post er</span>
                    </div>
                    <div
                      class="stats-container"
                      v-if="!isNaN(instagramProfileEr)"
                    >
                      <h5>{{ (instagramProfileEr * 100).toFixed(2) }}%</h5>
                      <span>profile er</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-5" style="padding-left: 25px;">
                <div class="row" style="margin-top:25px; margin-bottom:25px;">
                  <div class="col-md-12">
                    <badge type="primary">{{
                      postDetails.post.mediaType
                    }}</badge>
                    <badge type="danger" style="margin-left:5px;">{{
                      postDetails.post.postType
                    }}</badge>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <h5>
                      <a
                        :href="
                          '/instagram/content/' +
                            postDetails.post.instagramProfile
                        "
                        >@{{ postDetails.post.instagramProfile }}</a
                      >
                    </h5>
                    <p
                      style="font-size:12px; color: gray;"
                      v-if="postDetails.post.dateTakenString !== undefined"
                    >
                      posted {{ postDetails.post.dateTakenString }}
                    </p>
                    <p style="font-size:12px; color: gray;" v-else>
                      posted {{ postDetails.post.dateAddedString }}
                    </p>

                    <p style="white-space: pre-wrap;">
                      {{ postDetails.post.caption }}
                    </p>

                    <a
                      v-if="postDetails.post.postType == 'feed'"
                      target="_blank"
                      :href="
                        'https://instagram.com/p/' + postDetails.post.shortcode
                      "
                      >https://instagram.com/p/{{
                        postDetails.post.shortcode
                      }}</a
                    >
                  </div>
                </div>
                <div
                  class="row"
                  style="margin-top:10px; margin-bottom:25px;"
                  v-if="postDetails.post.hashtags !== undefined"
                >
                  <div class="col" v-if="postDetails.post.hashtags.length > 0">
                    <h6>Hashtags:</h6>
                    <span
                      class="font-size:12px;"
                      v-for="hashtag in postDetails.post.hashtags"
                      :key="hashtag"
                      >#{{ hashtag }}&nbsp;</span
                    >
                  </div>
                </div>
                <div class="row" v-if="postDetails.stats !== undefined">
                  <div
                    style="margin-top:10px; margin-bottom:25px;"
                    v-if="postDetails.stats.rankedHashtags !== undefined"
                  >
                    <div
                      class="col"
                      v-if="postDetails.stats.rankedHashtags.length > 0"
                    >
                      <h6>Ranked Hashtags:</h6>
                      <span
                        v-for="hashtag in postDetails.stats.rankedHashtags"
                        :key="hashtag"
                        >#{{ hashtag }} &nbsp;</span
                      >
                    </div>
                    <div class="col" v-else>none</div>
                  </div>
                  <div
                    v-else
                    class="col"
                    style="margin-top:10px; margin-bottom:25px;"
                  >
                    <h6>Ranked Hashtags:</h6>
                    none
                  </div>
                </div>
                <div class="row" v-if="collabPostsActive.length > 0">
                  <div class="col">
                    <hr />
                    <h6>CAMPAIGNS:</h6>
                    <div
                      v-for="campaign in collabPostsActive"
                      :key="campaign._id"
                    >
                      <div style="float:left; width:300px; padding-top:10px;">
                        {{ campaign.client.businessName }} - {{ campaign.name }}
                      </div>
                      <div style="float:left;">
                        <p-button
                          round
                          outline
                          type="danger"
                          @click="archiveCollaboration(campaign._id)"
                          size="sm"
                        >
                          <i style="fa fa-trash-alt"></i> remove
                        </p-button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row" v-if="openCampaigns.length > 0">
                  <div class="col">
                    <hr />
                    <h6>Add to Campaign:</h6>
                    <div v-if="collabFormProps !== null">
                      <vue-autosuggest
                        v-model="selectCollaboration"
                        :suggestions="campaignDropdown"
                        @selected="saveCollaboration"
                        :input-props="collabFormProps"
                        @input="filterCampaigns"
                        @click="clickHandler"
                      ></vue-autosuggest>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col">
                    <p-button
                      type="info"
                      @click="navigateDownload(postDetails.post.shortcode)"
                      round
                      >Download Content</p-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import _ from "underscore";
import { VueAutosuggest } from "vue-autosuggest";
import {
  loadInstagramProfile,
  instagramPostDetailsApi,
  influencerCampaignReadApi,
  influencerCollaborationListApi,
  userLoadApi,
  influencerCollabPostAddApi,
  influencerCollabPostCheckApi,
  influencerCollabPostArchiveApi,
  loadInstagramProfilePublic,
  instagramPostCacheApi,
} from "@/config/appSettings";
import { mapGetters, mapActions } from "vuex";
import store from "@/store/index.js";
import IgProfile from "@/libs/ig/profileData";
import { Badge } from "src/components/UIComponents";
const Math = require("mathjs");
export default {
  data: () => ({
    auth: null,
    loadingOverlay: false,
    loadingPostStats: false,
    loadingOverlayText: null,
    profile: null,
    instagramProfile: null,
    profileSearch: null,
    postDetails: null,
    currentInstagram: null,
    campaigns: [],
    selectCollaboration: null,
    collabFormProps: null,
    campaignDropdown: [],
    currentInstagramId: null,
    collabPostsActive: [],
    openCampaigns: [],
    totalPostEngagement: null,
    postEngagementRate: null,
    hashtagsUsed: [],
    hashtagsRanked: [],
    instagramProfileEr: null,
    postStats: {
      likeCount: null,
      viewCount: null,
      commentCount: null,
    },
  }),
  components: {
    VueAutosuggest,
    [Badge.name]: Badge,
  },
  name: "InstagramPostDetail",
  methods: {
    async navigateDownload(shortcode) {
      this.$router.push("/instagram/download/" + shortcode);
    },
    async loadPostInstagramProfile() {
      try {
        let profileDetailUrl = `${loadInstagramProfilePublic}/?usertoken=${this.auth}&instagram=${this.postDetails.post.instagramProfile}`;
        //console.log("PROFILE DETAIL URL:", profileDetailUrl)
        let profileDetail = await axios.get(profileDetailUrl);
        //console.log("PROFILE DATA: ", profileDetail.data);
        if (profileDetail.data.success === true) {
          this.instagramProfile = profileDetail.data.result;
          this.instagramProfileEr = this.instagramProfile.engagementRate
        }
      } catch (err) {
        console.log("ERR:", err);
      }
    },
    async postLoadCache(instagramProfile) {
      try {
        let postCacheUrl = `${instagramPostCacheApi}/?usertoken=${this.auth}&shortcode=${this.$route.params.shortcode}`;
        //console.log("POST CACHE:", postCacheUrl);
        let postCacheResponse = await axios.get(postCacheUrl);
        
        //console.log(`LOADING ${instagramProfile}`, profileCacheResponse.data);
      } catch (err) {
        console.log("ERR", err);
      }
    },
    async loadPost() {
      // THIS IS PAGE
      try {
        let postCheckUrl = `${instagramPostDetailsApi}/?usertoken=${this.auth}&shortcode=${this.$route.params.shortcode}`;
        //console.log("POST CHECK URL:", postCheckUrl);
        let instagramPostResponse = await axios.get(postCheckUrl);
        //console.log("POST DATA:", instagramPostResponse.data);
        if (instagramPostResponse.data.success == true) {
          //console.log("POST DATA:", instagramPostResponse.data.result);
          this.postDetails = instagramPostResponse.data.result;

          this.totalPostEngagement = 0;
          if (typeof this.postDetails.post.likeCount !== "undefined") {
            if (!isNaN(this.postDetails.post.likeCount)) {
              //console.log("LIKE COUNT:", this.postDetails.post.likeCount);
              this.postStats.likeCount = this.postDetails.post.likeCount;
              this.totalPostEngagement =
                this.totalPostEngagement +
                parseInt(this.postDetails.post.likeCount);
            }
          }
          if (typeof this.postDetails.post.commentCount !== "undefined") {
            if (!isNaN(this.postDetails.post.commentCount)) {
              //console.log("COMMENT COUNT:", this.postDetails.post.commentCount);
              this.postStats.commentCount = this.postDetails.post.commentCount;
              this.totalPostEngagement =
                this.totalPostEngagement +
                parseInt(this.postDetails.post.commentCount);
            }
          }

          if (typeof this.postDetails.post.viewCount !== "undefined") {
            if (!isNaN(this.postDetails.post.viewCount)) {
              ///console.log("COMMENT COUNT:", this.postDetails.post.viewCount);
              this.postStats.viewCount = this.postDetails.post.viewCount;
              this.totalPostEngagement =
                this.totalPostEngagement +
                parseInt(this.postDetails.post.viewCount);
            }
          }

          try {
            if (this.postDetails.post.hashtags.length > 0) {
              this.hashtagsUsed = this.postDetails.post.hashtags;
            }
          } catch (err) {
            console.log("NO HASHTAGS");
          }
        }
      } catch (err) {
        console.log("ERROR:", err);
      }
    },
    async calculateER() {
      try {
        //console.log("POST ENGAGEMENT:", this.totalPostEngagement);
        //console.log("FOLLOER COUNT: ", this.instagramProfile.followerCount);
        if (this.totalPostEngagement > 0) {
          this.postEngagementRate =
            this.totalPostEngagement /
            parseInt(this.instagramProfile.followerCount);
          //console.log("POST ENGAGEMENT RAW:", this.postEngagementRate);
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadCampaignList() {
      try {
        if (this.isTeam == true) {
          // NEED TO PERFORM SEPARATE LOOKUP FOR PROFILE

          let influencerCampaignLoadUrl = `${influencerCollaborationListApi}/?usertoken=${this.auth}&instagram=${this.currentInstagramId}`;
          let influencerCollabList = await axios.get(influencerCampaignLoadUrl);
          //console.log("CAMPAIGN DATA: ", influencerCollabList.data);
          if (influencerCollabList.data.success === true) {
            this.campaigns = influencerCollabList.data.result;
            this.loadingOverlay = false;
          }
        }
        if (this.isInfluencer === true) {
          this.currentInstagramId = this.currentInstagram.instagramId;
          let influencerCampaignLoadUrl = `${influencerCollaborationListApi}/?usertoken=${this.auth}&instagram=${this.currentInstagram.instagramId}`;
          let influencerCollabList = await axios.get(influencerCampaignLoadUrl);
          //console.log("CAMPAIGN DATA: ", influencerCollabList.data);
          if (influencerCollabList.data.success === true) {
            this.campaigns = influencerCollabList.data.result;
            this.loadingOverlay = false;
          }
        }
      } catch (err) {
        console.log("CAMPAIGN LIST ERROR: ", err);
      }
    },
    async setProfileType() {
      //console.log("LOADING PROFILE FROM NAV:", this.profileStore);
      if (this.profileStore !== false) {
        this.profileData = this.profileStore;
        if (this.profileStore.isTeam === true) {
          this.isTeam = true;
        }
        try {
          if (this.profileStore.isInfluencer === true) {
            this.isInfluencer = true;
          }
          if (this.profileStore.isClient === true) {
            this.isInfluencer = true;
          }
        } catch (err) {
          //console.log("ERROR:", err);
        }

        return;
      }
      // IF NOT LOADED YET LOAD DIRECTLY TO SET PROFILE TYPE
      //console.log("PROFILE STORE MAIN:", this.profileStore);
      if (this.profileStore === false) {
        let profileLoadResponse = await axios.get(`${userLoadApi}${this.auth}`);
        // console.log("PROFILE DATA MAIN FROM NAV:", profileLoadResponse.data);
        if (profileLoadResponse.data.success === true) {
          this.profileData = profileLoadResponse.data.result;
          store.dispatch("updateProfile", profileLoadResponse.data.result);

          if (profileLoadResponse.data.result.isTeam === true) {
            this.isTeam = true;
            //await this.buildMenu();
            return;
          }
          try {
            if (profileLoadResponse.data.result.profileTypes.length > 0) {
              if (
                profileLoadResponse.data.result.profileTypes.indexOf(
                  "influencer"
                ) !== -1
              ) {
                this.isInfluencer = true;
                //console.log("PROFILE TYPE: INFLUENCER");
              }
              if (
                profileLoadResponse.data.result.profileTypes.indexOf(
                  "client"
                ) !== -1
              ) {
                this.isClient = true;
                //console.log("PROFILE TYPE: CLIENT");
              }
              return;
            }
          } catch (err) {
            //console.log("ERROR:", err);
          }
        } else {
          return;
          //console.log("PROFILE LOAD FAILED");
        }
        //console.log("HERE IS THE PROFILE DATA:", this.profileData)
      }
    },

    async filterCampaigns(input) {
      //console.log("FILTERING...", input);
    },
    async saveCollaboration(input) {
      //console.log("ITEM:", input);
      //this.setCampaignValue(input);

      let selectedCollab = this.campaigns.filter((x) => {
        return `${x.client.businessName} - ${x.name}` == input.item;
      });
      //console.log("SELECTED COLLAB:", selectedCollab);

      let newCollabPost = {};
      newCollabPost.shortcode = this.$route.params.shortcode;
      newCollabPost.usertoken = this.auth;
      newCollabPost.campaign = selectedCollab[0]._id;

      //console.log("NEW COLLAB POST:", newCollabPost);
      let addPostResponse = await axios.post(
        influencerCollabPostAddApi,
        newCollabPost
      );
      //console.log("RESPONSE:", addPostResponse.data);
      if (addPostResponse.data.success == true) {
        await this.campaignPostCheck();
        await this.setCampaignDropdown();
      }
    },

    async archiveCollaboration(campaignId) {
      //console.log("ITEM:", input);
      //this.setCampaignValue(input);

      let archiveCollab = {};
      archiveCollab.shortcode = this.$route.params.shortcode;
      archiveCollab.usertoken = this.auth;
      archiveCollab.campaign = campaignId;
      //console.log("NEW COLLAB POST:", archiveCollab);
      let archivePostResponse = await axios.post(
        influencerCollabPostArchiveApi,
        archiveCollab
      );
      //console.log("RESPONSE:", archivePostResponse.data);
      if (archivePostResponse.data.success == true) {
        await this.campaignPostCheck();
        await this.setCampaignDropdown();
      }
    },

    async clickHandler(item) {
      // event fired when clicking on the input
      //console.log("CLICK ITEM:", item);
    },
    async campaignPostCheck() {
      // event fired when clicking on the input
      try {
        if (this.campaigns.length > 0) {
          let campaignIds = this.campaigns.map((x) => {
            return x._id;
          });
          let campaignString = campaignIds.join(",");
          let postCheckResponse = await axios.get(
            `${influencerCollabPostCheckApi}/?usertoken=${this.auth}&shortcode=${this.$route.params.shortcode}&campaigns=${campaignString}`
          );
          //console.log("CAMPAIGN POST CHECK:", postCheckResponse);
          let collabPostList = postCheckResponse.data.result.map((x) => {
            return this.campaigns.map((campaign) => {
              if (campaign._id == x.campaignId) {
                return campaign;
              }
              return [];
            });
          });
          this.collabPostsActive = _.flatten(collabPostList);
          //console.log("MATCHED CAMPAIGN:", this.collabPostsActive);
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async setCampaignDropdown() {
      try {
        console.log("CAMPAIGNS:", this.campaigns);
        let collabPostCampaignIds = this.collabPostsActive.map((x) => {
          return x._id;
        });

        //console.log("COLLAB POST IDS:", collabPostCampaignIds);
        this.openCampaigns = this.campaigns.filter((x) => {
          return collabPostCampaignIds.indexOf(x._id) == -1;
        });
        //console.log("OPEN CAMPAIGNS:", this.openCampaigns);
        this.campaignDropdown = [
          {
            data: this.openCampaigns.map((x) => {
              return `${x.client.businessName} - ${x.name}`;
            }),
          },
        ];
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadPageContent() {
      // THIS IS PAGE
      this.loadingOverlay = true;
      this.loadingOverlayText = "Loading...";
      await this.loadPost();
      this.loadingOverlay = false;
      this.loadingPostStats = true;
      await this.loadPostInstagramProfile();
      this.calculateER();
      this.loadingPostStats = false;
      await this.setProfileType();
      //console.log("SHOW PROFILE STORE:", this.profileStore);
      try {
        try {
          if (this.profileStore.profileTypes.indexOf("influencer") !== -1) {
            this.isInfluencer = true;
          }
        } catch (err) {}

        if (this.profileStore.isTeam == true) {
          console.log("IS TEAM");
          this.isTeam = true;
          console.log("INSTAGRAM ID:");
          if (this.instagramProfile !== null) {
            this.currentInstagramId = this.postDetails.post.instagramId;
            console.log("CURRENT INSTAGRAM ID:", this.currentInstagramId);
            console.log("LOADING CAMPAIGN LIST...");
            await this.loadCampaignList();
            this.collabFormProps = {
              id: "autosuggest__input",
              onInputChange: this.campaigns,
              placeholder: "Select a Campaign",
            };
            //console.log("SHOWING COLLAB PROPERTIES:", this.collabFormProps);
            await this.campaignPostCheck();
            await this.setCampaignDropdown();
          }
        }
        if (this.isInfluencer == true) {
          //console.log("PROFILE:", this.profileStore);
          this.currentInstagram = this.profileStore.relatedInfluencers[0];

          if (
            this.postDetails.post.instagramProfile ==
            this.currentInstagram.instagramProfile
          ) {
            await this.loadCampaignList();
            this.collabFormProps = {
              id: "autosuggest__input",
              onInputChange: this.campaigns,
              placeholder: "Select a Campaign",
            };
            await this.campaignPostCheck();
            await this.setCampaignDropdown();
          }
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
  },

  mounted() {
    this.auth = firebase.auth().currentUser.uid;
    this.loadPageContent();
  },
  computed: {
    ...mapGetters(["profileStore"]),
  },
};
</script>

<style scoped>
#autosuggest__input {
  outline: none;
  position: relative;
  display: block;
  border: 1px solid #616161;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}

.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  z-index: 10000001;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  padding: 0px;
}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results .autosuggest__results-item {
  cursor: pointer;
  padding: 15px;
}

#autosuggest ul:nth-child(1) > .autosuggest__results_title {
  border-top: none;
}

.autosuggest__results .autosuggest__results_title {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results
  .autosuggest__results-item.autosuggest__results-item--highlighted {
  background-color: #f6f6f6;
}
.stats-container {
  text-align: center;
  /*width: 200px;
  float: left;*/
  padding: 10px;
  margin-right: 20px;
  display: inline-block;
}
.stats-container span {
  font-size: 12px;
  color: gray;
}
.stats-container h5 {
  font-size: 18px;
  margin: 0px;
  padding: 0px;
}
.video_container {
  position: relative;
}
.video_container img.poster {
  width: 100%;
  height: auto;
  position: relative;
  z-index: 10;
}
.video-contain {
  position: relative;
  top: 0;
  left: 0;
  max-width: 100%;
  background: #ccc; /* Random BG colour for unloaded video elements */
}
</style>
